import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Input, Select, Button, Space, DatePicker, InputNumber, Form, Checkbox } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
const { Option } = Select;

const ColumnFilter = forwardRef(({ name, title, type, filter}, ref) => { 
    const [operator, setOperator] = useState('');
    const [value, setValue] = useState('');	

    useEffect(() => { 
        setOperator(filter.operator); 
        setValue(filter.value); 
    },[filter])

    useImperativeHandle(ref, () => ({
        getFilter: ()=>({field:name, operator, value }),    
    }))

    function getopers(type) {
        return [
            ['is','=',['text','number','date','boolean']],
            ['lt','<',['number','date']],
            ['gt','>',['number','date']],
            ['le','<=',['number','date']],
            ['ge','>=',['number','date']],
            ['between','mezi',['number','date']],
            ['contains','obsahuje',['text']],
            ['begins','začíná', ['text']],
            ['ends','končí',['text']],
            ['is null','null',['text','number','date','boolean']],
            ['is not null','not null',['text','number','date','boolean']],
        ].filter(e=>e[2].includes(type)).map(e=>{return {key:e[0],value:e[1]}})
    }
    console.log('REFRESH',name,operator,value)
    return ( 
    <div ref={ref} style={{display: 'grid', gridTemplateColumns: '150px 100px 120px 120px', gap: '10px'}}>
        <span style={{ textAlign: 'right'}}>{title}</span>
        <Select value={operator} onChange={value => setOperator(value)}>
            {getopers(type).map(e => <Option key={e.key} value={e.key}>{e.value}</Option>)} 
        </Select>
        {   
            type=='number' && operator == 'between' ?	
            <>
            <InputNumber 
                id={`input${name}1`} 
                value={Array.isArray(value)?value[0]:undefined} style={{ width: 120 }}
                onChange={value => setValue(v=>[value,Array.isArray(v)?v[1]:0])} 
            />
            <InputNumber 
                id={`input${name}2`} 
                value={Array.isArray(value)?value[1]:undefined} style={{ width: 120 }}
                onChange={value => setValue(v=>[Array.isArray(v)?v[0]:0,value])} 
            />
            </>     
        :   type=='number'?	
            <InputNumber 
                id={`input${name}`} 
                value={value} style={{ width: 120 }}
                onChange={value => setValue(value)} 
            />

        : 	type=='date' && operator == 'between'?
            <DatePicker.RangePicker
                id={`input${name}`}
                format="DD.MM.YYYY" style={{ width: 250}}
                value={value} onChange={value => setValue(value)}	
            />
        : 	type=='date'?
            <DatePicker
                id={`input${name}`}
                format="DD.MM.YYYY"
                value={value} onChange={value => setValue(value)}	
            />

        :   type=='boolean'?
            <Checkbox
                id={`input${name}`} 
                checked={!!value} onChange={e => setValue(e.target.checked)}
            />

        : 	<Input
                id={`input${name}`} 
                value={value} onChange={e => setValue(e.target.value)}	
            />
        }
    </div>
    )		
})

const FilterForm = forwardRef( function(props,ref){
    const [form] = Form.useForm();
    const columnRefs = useRef({});
    const btnRef = useRef(null);
    const cbs = useRef({});
    const [_,setRefresh] = useState(0)
    
    /*
    useEffect(() => {
        console.log('mounting')
        return ()=>{
            console.log('unmounting')
        }
    }, []);
    */
    useImperativeHandle(ref, () => ({
        open(columns,searches,onFinish,onReset) {
            cbs.current = {onFinish, onReset, filters: makeFilters(columns, searches) };
            setRefresh(r => r + 1);
        }
    }))

    function setColumnRef(element, index){
        if (element) columnRefs.current[index] = element; else delete columnRefs.current[index];
    };
    
    function makeFilters(columns,searches){
        const ss = searches.reduce((acc, e) => { acc[e.field] = e; return acc; }, {});  
        const ff = columns.filter(e=>e.options?.searchable).map((column,index) => {
            const opt = column.options ?? {}
            const type = opt.type ?? 'text'
            const name = Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex
            const title = column.title;
            const s = ss[name]
            const filter = (s?{operator:s.operator,value:s.value}:null) || opt.filter || {}
            return {name,title,type,filter}        
        });
        return ff.map((f,index) => { 
            return <ColumnFilter key={f.name} name={f.name} title={f.title} type={f.type} filter={f.filter} ref={(element) => setColumnRef(element, index)} />;
        })
    }

    function handleReset() { 
        if(cbs.current.onReset) cbs.current.onReset();
    }

    function handleFinish() {
        const searches = Object.keys(columnRefs.current).map((k) => columnRefs.current[k].getFilter()).filter(e => e.operator == 'is null' || e.operator == 'is not null' || e.operator && e.value !== undefined && e.value !== null && e.value !== ''); 
        if(cbs.current.onFinish) cbs.current.onFinish(searches);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') btnRef.current?.click();
    }

    return (
        <div ref={ref} onKeyDown={handleKeyDown}>
            <Form form={form    } style={{ display: 'grid', gridTemplateColumns: 'auto', alignItems: 'center', gap: '10px', padding: '10px'}}>

            { cbs.current?.filters }
            
            <Space style={{ margin:'auto'}}>
                <Button type="primary" icon={<SearchOutlined />} onClick={handleFinish} ref={btnRef}>Hledat</Button>
                <Button type="default" icon={<ReloadOutlined />} onClick={handleReset}>Resetovat</Button>
            </Space>
            
            </Form>
        </div>
    );
})	

export default FilterForm;